import store from "@/store";
import { McGePoint3d } from "mxcad";

import * as THREE from "three";
// 创建一个 WeakMap 来缓存实体对象
const entityCache = new WeakMap();

// 全图
export const FullView = () => {
  // 2D全图
  try {
    const data = store.state.rlEntData.totalEntityData;

    // 初始化全局最小值和全局最大值
    let minX = Infinity,
      minY = Infinity,
      minZ = Infinity;
    let maxX = -Infinity,
      maxY = -Infinity,
      maxZ = -Infinity;

    let dataEmpty = true; // 是否没有数据，若没有，不需要设置中心位置

    // 遍历 data 对象的所有值
    Object.values(data).forEach((value) => {
      // 如果值是数组，则继续遍历数组
      if (Array.isArray(value)) {
        value.forEach((res) => {
          dataEmpty = false;
          // console.log("res", res);
          // 检查是否已经缓存了实体对象
          let mcDbEntity = entityCache.get(res.mcDbId);
          if (!mcDbEntity) {
            // 如果没有缓存，则获取实体对象并缓存
            mcDbEntity = res.mcDbId.getMcDbEntity();
            entityCache.set(res.mcDbId, mcDbEntity);
          }
          // 获取包围盒
          let { ret, minPt, maxPt } = mcDbEntity.getBoundingBox();
          if (ret) {
            // 更新全局最小值
            minX = Math.min(minX, minPt.x);
            minY = Math.min(minY, minPt.y);
            minZ = Math.min(minZ, minPt.z);

            // 更新全局最大值
            maxX = Math.max(maxX, maxPt.x);
            maxY = Math.max(maxY, maxPt.y);
            maxZ = Math.max(maxZ, maxPt.z);
          }

          // 如果有方法释放 minPt 和 maxPt，请在此调用
          // 否则，将引用置为 null，帮助垃圾回收
          minPt = null;
          maxPt = null;
        });
      }
    });
    //无数据时，设置全图为中心点0,0
    if (dataEmpty) {
      rlAppObj.mxcadObject.zoomW(
        new McGePoint3d(-10000, -10000),
        new McGePoint3d(10000, 10000)
      );
    }
    if (dataEmpty) return;

    // 创建全局最小点和最大点
    let globalMinPt = new McGePoint3d(minX, minY, minZ);
    let globalMaxPt = new McGePoint3d(maxX, maxY, maxZ);

    rlAppObj.mxcadObject.zoomW(globalMinPt, globalMaxPt);
    rlAppObj.mxcadObject.zoomScale(0.7);

    // 如果有必要，释放 globalMinPt 和 globalMaxPt
    // 否则，将引用置为 null，帮助垃圾回收
    globalMinPt = null;
    globalMaxPt = null;

    // 3D全图
    if (rlThreeObj.Tscene && rlThreeObj.Tscene.children.length > 0) {
      // 创建一个新的包围盒
      let boundingBox = new THREE.Box3();

      // 遍历所有的子对象
      rlThreeObj.Tscene.children.forEach((child) => {
        // 计算子对象的包围盒并合并到总的包围盒中
        boundingBox.expandByObject(child);
      });

      // 获取包围盒的中心点和大小
      let center = boundingBox.getCenter(new THREE.Vector3());
      let size = boundingBox.getSize(new THREE.Vector3());

      // 将控制器的目标点设置为包围盒的中心点
      rlThreeObj.Tcontrols.target.copy(center);

      // 设置相机的位置
      rlThreeObj.Tcamera.position.set(
        center.x,
        center.y + size.y * 1.5, // 高度
        center.z - size.z * 1.5 // 距离
      );

      // 清理变量引用
      boundingBox = null;
      center = null;
      size = null;
    }

    // 更新视图
    rlAppObj.rlMxDrawObject.updateDisplay();
  } catch (error) {
    console.error("全图视图更新失败：", error);
  }
};
